import { SimpleGrid, Box, Text } from '@chakra-ui/react';
import ProfileCard from '../districtProfile/ProfileCard'
import { IdeologyChart, TurnoutChart } from '../analyticsMap/charts/DistributionCharts'
import type { ListOverview } from '../../types/contactList'
import type { DashboardData } from '../../types/analyticsMap'

export function UniverseSummaryPanel({ overview }: { overview: ListOverview }) {
  const data: DashboardData = {
    totalContacts: overview.memberCount,
    ideologyDistribution: overview.ideologyDistribution,
    turnoutDistribution: overview.turnoutDistribution,
    partyBreakdown: overview.partyBreakdown,
    raceBreakdown: overview.raceBreakdown,
    ageDistribution: overview.ageDistribution,
  }
  return (
    <ProfileCard eyebrow="Universe summary" title="Who is this universe, politically">
      <SimpleGrid columns={{ base: 1, md: 2 }} gap={6} mt={3}>
        <Box>
          <Text fontSize="sm" fontWeight="medium" mb={1}>Ideology distribution</Text>
          <Text fontSize="xs" color="gray.500" mb={2}>0 = conservative · 100 = progressive</Text>
          <IdeologyChart data={data} />
        </Box>
        <Box>
          <Text fontSize="sm" fontWeight="medium" mb={1}>Turnout propensity</Text>
          <Text fontSize="xs" color="gray.500" mb={2}>Predicted likelihood to vote</Text>
          <TurnoutChart data={data} />
        </Box>
      </SimpleGrid>
    </ProfileCard>
  );
}
